"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionGroup = ActionGroup;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/ActionGroup/index.tsx
// アイコン + ラベルを縦並びにした ButtonBase を横方向に並べる
// アクション群。EventDetail のヘッダー下アクション (共有 / 通知 / その他) 等で利用。
//
// 色はすべて theme.palette.v2 (useV2Palette) から取得する。
//   - アイコン / ラベルの前景: foreground.neutral.secondary
//   - hover の地: background.overlayHover (light 黒 5% / dark 白 5%)
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function ActionGroup(_a) {
    var actions = _a.actions;
    var p = (0, theme_1.useV2Palette)();
    // ボタン間隔は Figma の 8px (アイコン中心の間隔 76px = 幅 68 + 8)。
    // spacing={1} は呼び出し側テーマの spacing 配列に依存して 4px になるため px で固定する。
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "row", spacing: "".concat(tokens_1.spacing.sm, "px"), alignItems: "center", children: actions.map(function (action, i) { return ((0, jsx_runtime_1.jsxs)(material_1.ButtonBase, __assign({}, (action.href ? { href: action.href } : {}), { onClick: action.onClick, disabled: action.disabled, sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: "".concat(tokens_1.spacing.xs, "px"),
                p: "".concat(tokens_1.spacing.xs, "px"),
                borderRadius: "".concat(tokens_1.radius.sm, "px"),
                width: 68,
                minHeight: 50,
                color: p.foreground.neutral.secondary,
                opacity: action.disabled ? 0.4 : 1,
                transition: 'background-color 0.15s ease',
                '@media (hover: hover)': {
                    '&:hover': {
                        backgroundColor: action.disabled
                            ? 'transparent'
                            : p.background.overlayHover,
                    },
                },
            }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '& > svg': { fontSize: 24 },
                    }, children: action.icon }), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                        fontSize: tokens_1.fontSize['2xs'],
                        fontWeight: tokens_1.fontWeight.semiBold,
                        lineHeight: 1.2,
                        color: 'inherit',
                        textAlign: 'center',
                        whiteSpace: 'pre-wrap',
                    }, children: action.label })] }), i)); }) }));
}
